import React, { FC } from 'react'
import classNames from 'classnames'
import { LabelMD, LabelSM } from '@/atoms/Text'

interface Props {
  title: string
  subTitle: string
  selected: boolean
  onClick: () => void
  ticketQuantity: number
  ticketPrice: number
}

export const TicketOption: FC<Props> = ({ title, subTitle, selected, onClick, ticketPrice, ticketQuantity }) => {
  return (
    <div key={title} className="radio grow-1 select-none" onClick={onClick}>
      <label
        className={classNames(
          'flex w-full cursor-pointer items-center justify-center py-3 pl-4 pr-6 border rounded-full flex-grow-1 gap-2',
          {
            'border-core-gray-950 bg-core-gray-950': selected,
            'border-core-gray-400 hover:bg-white': !selected,
          },
        )}
      >
        <span
          className={classNames('relative h-6 w-6 rounded-full border-[6px]', {
            'border-oxide-bright': selected,
            'border-core-gray-400': !selected,
          })}
        />
        <div className="flex flex-col gap-1 text-left">
          <LabelMD color={selected ? 'white' : 'core-gray-950'}>{title}</LabelMD>
          <LabelSM color={selected ? 'core-gray-500' : 'core-gray-600'}>{subTitle}</LabelSM>
        </div>
        <div className="ml-auto flex flex-col gap-1 text-right">
          <LabelMD color={selected ? 'core-gray-500' : 'core-gray-600'} className="line-through">
            ${ticketQuantity * ticketPrice}
          </LabelMD>
          <LabelSM color={selected ? 'white' : 'core-gray-950'}>${(ticketQuantity / 2) * ticketPrice}</LabelSM>
        </div>
      </label>
    </div>
  )
}
